<template>
  <div class="ag-input-text-wrapper">
    <input
      :id="params.filterParams.fieldId"
      ref="eFloatingFilterText"
      :value="currentValue"
      class="ag-floating-filter-input"
      type="text"
      @input="valueChanged"
    />

    <div class="btn-wrapper">
      <small :class="{ active: isNaBtnActive }" class="na-btn" @click="toggleNaBtn(!isNaBtnActive)">N/A</small>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import cleaveMixin from '@/mixins/cleave-mixin'
import { debounce } from 'lodash'

export default Vue.extend({
  mixins: [cleaveMixin],

  data: function() {
    return {
      currentValue: null,
      isNaBtnActive: false
    }
  },

  created() {
    this.valueChanged = debounce(
      function(event) {
        this.toggleNaBtn(false)
        const value = event.target.value
        const formattedPrice = this.formatInputNumber(value)
        const number = this.convertToNumber(formattedPrice) || null
        this.currentValue = value ? this.formatPrice(value) : null
        this.params.parentFilterInstance(function(instance) {
          instance.onFloatingFilterChanged('equals', number)
        })
      }.bind(this),
      this.params.debounceMs
    )
  },

  mounted() {
    this.inputPriceFormat(`#${this.params.filterParams.fieldId}`)
  },

  methods: {
    onParentModelChanged(parentModel) {
      this.currentValue = !parentModel ? null : parentModel.filter ? this.formatPrice(parentModel.filter) : null
    },

    buildModel() {
      if (!this.currentValue) return null
      return {
        filterType: 'number',
        type: 'equals',
        filter: this.currentValue,
        filterTo: null
      }
    },

    toggleNaBtn(toggle) {
      this.isNaBtnActive = toggle
      const val = this.isNaBtnActive ? 'n/a' : null
      this.currentValue = val
      this.params.parentFilterInstance(function(instance) {
        instance.onFloatingFilterChanged('equals', val)
      })
    }
  }
})
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.ag-input-text-wrapper {
  padding 7px
  width 100%

  input:focus {
    border-bottom: 2px solid $primary !important;
  }

  .btn-wrapper {
    position: absolute;
    display flex
    justify-content center
    align-items center
    background: white;
    top: 13px;
    width: 32px;
    height: 27px;
    right: 5px;
    border-radius: 0 5px 5px 0;

    .na-btn {
      border 1px solid $tertiary
      border-radius 3px
      color $tertiary
      padding: 2px;
      background: white;
      cursor: pointer;

      &.active {
        background $tertiary
        color white
      }
    }
  }

}
</style>
